import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import MoodActions, { MoodRedux, MoodTypes } from '../Redux/Mood'

const MoodCRUDObservable = createCRUDObservable({
  mainRedux: MoodRedux,
  reduxPath: 'mood',
})

export const MoodObservers = Object.assign({}, MoodCRUDObservable.observers, {})


export const MoodEpic = combineEpics(
  MoodCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/MoodObservable.js